import React from 'react';
import { useNavigate, useRouteError } from 'react-router-dom';
import MainWrapper from './MainWrapper';
import { Button, Center, Code, Flex, Heading, IconButton, Text } from '@chakra-ui/react';
import { FormattedMessage } from 'react-intl';
import { Title } from 'react-head';
import { APP_NAME } from 'constants/autoforms';
import NavigationBar from 'components/layout/NavigationBar';
import StatusBar from 'components/layout/StatusBar';
import { isDevelopment } from 'utils/utils';
import { ReactComponent as BackArrow } from 'icons/arrow-forward.svg';
import { ReactComponent as CopyIcon } from 'icons/copy-circled.svg';
import { copyTextToClipboard } from 'services/utils';
import { format } from 'date-fns';

const RootErrorElement = () => {
    const detailsRef = React.useRef(null);
    const error = useRouteError();
    const navigate = useNavigate();

    const handleCopy = () => {
        copyTextToClipboard(detailsRef?.current?.innerText);
    };

    return (
        <>
            <Title>{APP_NAME}</Title>
            <NavigationBar />
            <MainWrapper>
                <Center flexDir="column">
                    <Heading as="h1" variant="h1" mt={5}>
                        <FormattedMessage id="error_element_main_message" />
                    </Heading>
                    <Text mt={4}>
                        <FormattedMessage id="error_element_helper_message" />
                    </Text>
                    <Button
                        variant="primary"
                        my={4}
                        onClick={() => navigate(-1)}
                        leftIcon={<BackArrow style={{ transform: 'rotate(180deg)' }} />}
                    >
                        Go Back
                    </Button>
                    {isDevelopment && (
                        <Flex
                            position="relative"
                            flexDir="column"
                            p={8}
                            my={2}
                            maxWidth={'900px'}
                            maxHeight={'38em'}
                            borderWidth="1px"
                            borderRadius="md"
                            overflow={'auto'}
                        >
                            <Flex position="absolute" top={2} right={2}>
                                <IconButton
                                    aria-label={'click to copy details to clipboard'}
                                    size="xs"
                                    variant="circular-icon"
                                    cursor="pointer"
                                    leftIcon={<CopyIcon />}
                                    onClick={handleCopy}
                                />
                            </Flex>
                            <Code bg="transparent" ref={detailsRef} w="100%" p={2}>
                                <Text my={1}>Error message: {error?.message}</Text>
                                <Text my={1}>{error?.stack}</Text>
                                <Text my={1}>{format(new Date(), 'Pp zzz')}</Text>
                            </Code>
                        </Flex>
                    )}
                </Center>
            </MainWrapper>
            <StatusBar />
        </>
    );
};

export default RootErrorElement;
